import { ADA_KEYBOARD_CLASS_NAME } from '../../constants';

export default class TabChildMenu {
  constructor(el) {
    this.$el = $(el);

    this.classes = {
      isHidden: 'is-hidden hidden',
      opacityZero: 'opacity-0',
      opacityFull: 'opacity-100 active-transition',
    };

    this.dom = {
      $tabList: this.$el.find('.tab-menu-child'),
      $tabs: this.$el.find('.tab-menu-child button'),
      $panels: this.$el.find('.list-motor-menu'),
      $html: $('html'),
    };

    this.attribute = {
      ariaControls: 'aria-controls',
    };
    this.keys = {
      end: 35,
      home: 36,
      left: 37,
      up: 38,
      right: 39,
      down: 40,
      delete: 46,
    };
    this.direction = {
      37: -1,
      38: -1,
      39: 1,
      40: 1,
    };
  }

  init() {
    this.addListeners();
  }

  // Bind listeners
  addListeners() {
    this.dom.$tabs.on('click', (e) => {
      this.clickEventListener(e);
    });
    this.dom.$tabs.on('keydown', (e) => {
      this.keydownEventListener(e);
    });
    this.dom.$tabs.on('keyup', (e) => {
      this.keyupEventListener(e);
    });
    this.dom.$tabs.on('focus', (e) => {
      if (this.dom.$html.hasClass(ADA_KEYBOARD_CLASS_NAME)) {
        this.focusEventHandler(e);
      }
    });
  }

  clickEventListener(event) {
    const tab = event.currentTarget;
    this.activateTab(tab, false);
  }

  keydownEventListener(event) {
    const key = event.keyCode;

    switch (key) {
      case this.keys.end:
        event.preventDefault();
        // Activate last tab
        this.activateTab(this.dom.$tabs[this.dom.$tabs.length - 1], true);
        break;
      case this.keys.home:
        event.preventDefault();
        // Activate first tab
        this.activateTab(this.dom.$tabs[0], true);
        break;
      // Up and down are in keydown
      // because we need to prevent page scroll >:)
      case this.keys.up:
      case this.keys.down:
        this.determineOrientation(event);
        break;
      default:
        break;
    }
  }

  // Handle keyup on tabs
  keyupEventListener(event) {
    const key = event.keyCode;
    switch (key) {
      case this.keys.left:
      case this.keys.right:
        this.determineOrientation(event);
        break;
      case this.keys.delete:
        this.determineDeletable(event);
        break;
      default:
        break;
    }
  }

  determineOrientation(event) {
    const key = event.keyCode;
    const vertical = this.dom.$tabList.attr('aria-orientation') === 'vertical';
    let proceed = false;
    if (vertical && key === this.keys.up || key === this.keys.down) {
      event.preventDefault();
      proceed = true;
    }
    if (!vertical && key === this.keys.left || key === this.keys.right) {
      proceed = true;
    }
    if (proceed) {
      this.switchTabOnArrowPress(event);
    }
  }

  // Either focus the next, previous, first, or last tab
  // depending on key pressed
  switchTabOnArrowPress(event) {
    const pressed = event.keyCode;

    if (this.direction[pressed]) {
      const { target } = event;
      if (this.dom.$tabs[$(target).index() + this.direction[pressed]]) {
        this.dom.$tabs[$(target).index() + this.direction[pressed]].focus();
      } else if (pressed === this.keys.left || pressed === this.keys.up) {
        this.focusLastTab();
      } else if (pressed === this.keys.right || pressed === this.keys.down) {
        this.focusFirstTab();
      } else {
        // do nothing
      }
    }
  }

  // Activates any given tab panel
  activateTab(tab, keydown) {
    if (!$(tab).hasClass('active')) {
      this.deactivateTabs();
      const positionLeft = $(tab)[0].offsetLeft;
      $(tab)
        .attr({
          tabindex: '0',
          'aria-selected': 'true',
        })
        .addClass('active');
      $(tab).parent().animate({scrollLeft: positionLeft - 100}, 800);
      $($(this.dom.$panels)[$(tab).index()]).removeClass(this.classes.isHidden);
      setTimeout(() => {
        $($(this.dom.$panels)[$(tab).index()]).addClass(this.classes.opacityFull);
        $($(this.dom.$panels)[$(tab).index()]).removeClass(this.classes.opacityZero);
      }, 50);
      if (keydown) {
        $(tab).focus();
      }
    }
  }

  // Deactivate all tabs and tab panels
  deactivateTabs() {
    this.dom.$tabs
      .attr({
        tabindex: '-1',
        'aria-selected': 'false',
      })
      .removeClass('active');
    this.dom.$panels.removeClass(this.classes.opacityFull);
    this.dom.$panels.addClass(this.classes.opacityZero);
    this.dom.$panels.addClass(this.classes.isHidden);
  }

  // Make a guess
  focusFirstTab() {
    this.dom.$tabs[0].focus();
  }

  // Make a guess
  focusLastTab() {
    this.dom.$tabs[this.dom.$tabs.length - 1].focus();
  }

  // Detect if a tab is deletable
  determineDeletable(event) {
    const { target } = event;
    if ($(target).attr('data-deletable') !== null) {
      // Delete target tab
      this.deleteTab(event, target);
      // Update arrays related to tabs widget
      this.dom.$tabs = this.dom.$tabList.find('button');
      this.dom.$panels = this.$el.find('.list-motor-menu');

      // Activate the closest tab to the one that was just deleted
      if ($(target).index() - 1 < 0) {
        this.activateTab(this.dom.$tabs[0]);
      } else {
        this.activateTab(this.dom.$tabs[$(target).index() - 1]);
      }
    }
  }

  // Deletes a tab and its panel
  deleteTab(event) {
    const { target } = event;
    const $panel = $(`#${$(target).attr(this.attribute.ariaControls)}`);
    $panel.remove();
    $(target).remove();
  }

  focusEventHandler(event) {
    const { target } = event;
    const focused = document.activeElement;

    if (target === focused) {
      this.activateTab(target, false);
    }
  }
}

const $tabs = $('.mod-tabs-child');
if ($tabs.length) {
  $tabs.each((_i, e) => {
    new TabChildMenu(e).init();
  });
}
